import { DelayedEmitter } from './emitter.js';
import { Listener } from './listener.js';
import { createLogger } from '../logger/logger.js';
import { getErrorMessage } from '../runtime/get-error-message.js';

export function createDelayedEmitter<T>(
  initialValue: Promise<T>,
): DelayedEmitter<T> {
  const listeners: Listener<T>[] = [];
  const logger = createLogger('delayed-emitter');

  let value = initialValue;
  return {
    value: async () => {
      return await value;
    },
    on: (cb: Listener<T>, signal: AbortSignal) => {
      signal.addEventListener(
        'abort',
        () => {
          const index = listeners.indexOf(cb);
          if (index >= 0) {
            listeners.splice(index, 1);
          }
        },
        { once: true },
      );
      listeners.push(cb);
      value
        .then((v) => cb(v))
        .catch((err) => {
          logger.error(getErrorMessage(err));
        });
    },
    emit(val: T) {
      value = Promise.resolve(val);
      for (const listener of listeners) {
        listener(val);
      }
    },
  };
}
